



























import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ComponentPainelFiltroColapsavel extends Vue {
  @Prop({ default: false }) aberto: boolean
  @Prop({ default: '' }) titulo: string
  @Prop({ default: '' }) descricao: string
  @Prop({ default: '' }) icone: string
  @Prop({ default: 'painel-filtro' }) dataCy: string

  get dataCyFechar(): string {
    return `${this.dataCy}-fechar`
  }

  @Emit('fechar')
  fechar() {}
}
